var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadar1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 121,
    viewBox: "0 0 126 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2199 120.119C29.1509 120.119 2.96193 94.535 1.94693 62.708C1.07493 62.506 0.424927 61.729 0.424927 60.797C0.424927 27.273 27.6969 0 61.2199 0C62.1539 0 62.9299 0.650996 63.1309 1.522C94.9599 2.537 120.544 28.727 120.544 60.797C120.544 93.507 93.9319 120.119 61.2199 120.119ZM63.1019 2.504C62.8659 3.325 62.1179 3.93 61.2199 3.93C29.8659 3.93 4.35493 29.441 4.35493 60.797C4.35493 61.694 3.75093 62.443 2.92893 62.678C3.92793 93.978 29.6829 119.136 61.2199 119.136C93.3889 119.136 119.562 92.966 119.562 60.797C119.562 29.259 94.4009 3.503 63.1019 2.504ZM61.2199 74.779C53.5099 74.779 47.2379 68.507 47.2379 60.797C47.2379 53.087 53.5099 46.813 61.2199 46.813C68.9319 46.813 75.2049 53.087 75.2049 60.797C75.2049 68.507 68.9319 74.779 61.2199 74.779ZM61.2199 48.778C54.5949 48.778 49.2029 54.17 49.2029 60.797C49.2029 67.423 54.5949 72.814 61.2199 72.814C67.8479 72.814 73.2389 67.423 73.2389 60.797C73.2389 54.17 67.8479 48.778 61.2199 48.778Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.432 59.7008C109.432 35.887 86.881 16.583 59.064 16.583V59.7008H109.432Z",
    fill: "#250DFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 43.064,
    y: 4.58301,
    width: 82.368,
    height: 75.1177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0999163 0 0 0 0 0.0302041 0 0 0 0 0.721517 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar1);
export default __webpack_public_path__ + "static/media/radar1.63fb7b31b400c058e227f7afbadbfff3.svg";
export { ForwardRef as ReactComponent };